import { useEffect, useState } from 'react';

const SCREEN_SIZE = {
    SMALL: 768,
    MEDIUM: 992,
    LARGE: 1200,
};

// SMNUI-25373: at viewport heights below this threshold, the inline SideNav
// cannot fit all merged admin items, and "More"-overflow alone is not
// sufficient because the overflow trigger itself can fall off-screen.
// Fall back to the small-screen behavior — full overlay only, no inline
// icon column — so all items remain reachable via the overlay no matter
// how short the viewport is. Symmetric with the existing SCREEN_SIZE.SMALL
// width threshold.
//
// Note: the medium-screen branch (601-768px width) renders the same icon
// column as large-screen mode, just with expansion routing to the overlay
// instead of inline. That means medium-mode does NOT solve the
// short-height reachability problem — only small-mode (no inline column)
// does. Hence this threshold routes to onSmallScreen, not onMediumScreen.
// const SHORT_HEIGHT_THRESHOLD = SCREEN_SIZE.SMALL;

export default ({
    hasEXTJS,
    hasFlexibleLayoutSidePanel,
    onSmallScreen,
    onMediumScreen,
    onLargeScreen,
}) => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState(null);

    useEffect(() => {
        function handleResize() {
            const width = window.innerWidth;
            // const height = window.innerHeight;
            // const isShort = height < SHORT_HEIGHT_THRESHOLD;

            // if (width <= 600 || hasFlexibleLayoutSidePanel || isShort) {
            if (width <= 600 || hasFlexibleLayoutSidePanel) {
                if (currentBreakpoint === 'small') return;
                onSmallScreen();
                setCurrentBreakpoint('small');

            } else if (
                (width > 600 && width <= SCREEN_SIZE.SMALL && !hasFlexibleLayoutSidePanel)
                || hasEXTJS
            ) {
                if (currentBreakpoint === 'medium') return;
                setCurrentBreakpoint('medium');
                onMediumScreen();
            } else {
                if (currentBreakpoint === 'large') return;
                setCurrentBreakpoint('large');
                onLargeScreen();
            }
        }

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [
        hasEXTJS,
        currentBreakpoint,
        onSmallScreen,
        onMediumScreen,
        onLargeScreen,
    ]);
};
